webpackJsonp([1],{

/***/ 10:
/***/ (function(module, exports) {

module.exports = {
	"apiurl": "http://kleppeter.uahnn.com/api",
	"spotifyurl": "",
	"appurl": "http://app.klappater.uahnn.com/#/",
	"facebook_id": 301006706977265
};

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Checkin__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Checkin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Checkin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Search__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Charts__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Profile__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Profile__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	linkActiveClass: 'active',

	routes: [{
		path: '/',
		name: 'Checkin',
		component: __WEBPACK_IMPORTED_MODULE_2__views_Checkin___default.a
	}, {
		path: '/profile',
		name: 'Profile',
		component: __WEBPACK_IMPORTED_MODULE_5__views_Profile___default.a,
		props: true
	}, {
		path: '/charts',
		name: 'Charts',
		component: __WEBPACK_IMPORTED_MODULE_4__views_Charts___default.a
	}, {
		path: '/search',
		name: 'Search',
		component: __WEBPACK_IMPORTED_MODULE_3__views_Search___default.a
	}]
}));

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(211),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(183)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(212),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	components: {
		'app-header': __WEBPACK_IMPORTED_MODULE_0__components_Header__
	}
});

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app-header',
	computed: {
		credits: function credits() {
			return __WEBPACK_IMPORTED_MODULE_0__storage__["a" /* default */].state.profile.credits;
		},
		location: function location() {
			return __WEBPACK_IMPORTED_MODULE_0__storage__["a" /* default */].state.location;
		},
		status_bar_info: function status_bar_info() {
			return this.infotext + this.location.name;
		}
	},
	data: function data() {
		return {
			infotext: "Laden..."
		};
	},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0__storage__["a" /* default */].dispatch('updateSuggestions');
		__WEBPACK_IMPORTED_MODULE_0__storage__["a" /* default */].dispatch('updateProfile');
		__WEBPACK_IMPORTED_MODULE_0__storage__["a" /* default */].dispatch('updateLocation');

		setInterval(function () {
			_this.refreshProfile();
		}, 30000);

		setInterval(function () {
			_this.refreshLocation();
		}, 3 * 60000);
	},
	mounted: function mounted() {
		this.infotext = "Eingecheckt in ";
	},

	methods: {
		refreshProfile: function refreshProfile() {
			console.log("Profil aktualisiert");
			__WEBPACK_IMPORTED_MODULE_0__storage__["a" /* default */].dispatch('updateProfile');
		},
		refreshLocation: function refreshLocation() {
			console.log("Spotify Token aktualisiert");
			__WEBPACK_IMPORTED_MODULE_0__storage__["a" /* default */].dispatch('updateLocation');
		}
	}
});

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'charts',

  computed: {
    charts: function charts() {
      return __WEBPACK_IMPORTED_MODULE_1__storage__["a" /* default */].state.suggestions;
    }
  },
  created: function created() {
    var _this = this;

    setInterval(function () {
      _this.updateCharts();
    }, 20000);
  },

  methods: {
    vote: function vote(suggestionId) {
      __WEBPACK_IMPORTED_MODULE_1__storage__["a" /* default */].dispatch('toggleVote', suggestionId);
    },
    updateCharts: function updateCharts() {
      __WEBPACK_IMPORTED_MODULE_1__storage__["a" /* default */].dispatch('updateSuggestions');
    }
  }
});

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'check-in',
  data: function data() {
    return {
      activation_code: ''
    };
  },
  mounted: function mounted() {
    this.activation_code = this.getQueryVariable("c");
    if (!this.activation_code) {
      this.activation_code = "";
    }
  },

  methods: {
    onSubmit: function onSubmit() {
      __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].register(this.activation_code);
    },
    getQueryVariable: function getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
});

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conf_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conf_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__conf_json__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'profile',
  data: function data() {
    return {
      facebook_button_text: "Mit Facebook einloggen",
      add_email_text: "E-Mail-Adresse hinzufügen",
      email_add_address: false,
      fb_has_conection: false,
      email_address: '',
      change_button_text: 'Ändern',
      nickname_change: false,
      nickname: ''
    };
  },

  computed: {
    user: function user() {
      return __WEBPACK_IMPORTED_MODULE_0__storage__["a" /* default */].state.profile;
    }
  },
  created: function created() {

    window.fbAsyncInit = function () {
      FB.init({
        appId: '1420513777994905',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v2.9'
      });
      FB.AppEvents.logPageView();
    };

    (function (d, s, id) {
      var js,
          fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    __WEBPACK_IMPORTED_MODULE_0__storage__["a" /* default */].dispatch('updateProfile');

    this.nickname = this.user.nick_name;
  },

  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].logout();
    },
    fbconnect: function fbconnect() {
      var _this = this;

      if (!this.fb_has_conection) {
        this.facebook_button_text = "Verbinde mit deinem Facebook-Konto";

        FB.login(function (response) {
          _this.fbCallback(response);

          if (response.status === 'connected') {
            _this.fb_has_conection = true;

            FB.api('/me', function (response) {
              _this.facebook_button_text = "Verbunden mit " + response.name;
              __WEBPACK_IMPORTED_MODULE_0__storage__["a" /* default */].dispatch('updateName', response.name);
            });
          } else {
            _this.facebook_button_text = "Verbindung fehlgeschlagen";
          }
        });
      } else {
        this.facebook_button_text = "Trenne mit deinem Facebook-Konto...";

        this.fb_has_conection = false;

        setTimeout(function () {
          _this.facebook_button_text = "Mit Facebook einloggen";
        }, 1000);
      }
    },
    fbCallback: function fbCallback(response) {

      console.log(response);
    },
    addemail: function addemail() {
      if (!this.email_add_address) {

        this.add_email_text = "E-Mail Adresse eintragen";
        this.email_add_address = true;
      } else {
        __WEBPACK_IMPORTED_MODULE_0__storage__["a" /* default */].dispatch('updateEmail', this.email_address);
      }
    },
    changenickname: function changenickname() {

      if (this.nickname_change) {
        console.log(this.nickname);

        __WEBPACK_IMPORTED_MODULE_0__storage__["a" /* default */].dispatch('updateNickname', this.nickname);

        this.change_button_text = "Ändern";

        this.nickname_change = false;
      } else {
        this.nickname = this.user.nick_name;

        this.change_button_text = "Speichern";

        this.nickname_change = true;
      }
    }
  }
});

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conf_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conf_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__conf_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__storage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  data: function data() {
    return {
      search_query: '',
      query: '',
      offset: 0,
      limit: 10,
      results: []
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.offset = 0;
      if (this.search_query.length > 0) {
        console.log(__WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].getSpotifyHeader());
        this.query = this.search_query.replace(' ', '+');
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.spotify.com/v1/search?q=' + this.query + '&type=track&limit=' + this.limit + '&offset=' + this.offset + '&market=CH', { headers: __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].getSpotifyHeader() }).then(function (response) {
          return _this.results = response.data.tracks.items;
        });
      }
    },
    showMoreResults: function showMoreResults() {
      var _this2 = this;

      this.offset += 10;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.spotify.com/v1/search?q=' + this.query + '&type=track&limit=' + this.limit + '&offset=' + this.offset + '&market=CH', { headers: __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].getSpotifyHeader() }).then(function (response) {
        return _this2.results = _this2.results.concat(response.data.tracks.items);
      });
    },
    suggestSong: function suggestSong(song, event) {
      if (event.target.className == "fa fa-plus-circle") {
        event.target.className = "fa fa-check";
      }

      if (__WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].state.profile.credits <= 0) {
        console.log("Not enough credits!");
        return false;
      }

      __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].dispatch('addSuggestion', song);
    }
  }
});

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(5);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__webpack_require__(141);
var store = __webpack_require__(12);

__WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].checkAuth();

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {

	if (!__WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].user.authenticated && to.path === '/') {
		next();
	}

	if (__WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].user.authenticated) {
		if (to.path === '/') {
			__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/profile');
		} else {
			next();
		}
	} else {
		__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
	}
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 24,
	"./af.js": 24,
	"./ar": 31,
	"./ar-dz": 25,
	"./ar-dz.js": 25,
	"./ar-kw": 26,
	"./ar-kw.js": 26,
	"./ar-ly": 27,
	"./ar-ly.js": 27,
	"./ar-ma": 28,
	"./ar-ma.js": 28,
	"./ar-sa": 29,
	"./ar-sa.js": 29,
	"./ar-tn": 30,
	"./ar-tn.js": 30,
	"./ar.js": 31,
	"./az": 32,
	"./az.js": 32,
	"./be": 33,
	"./be.js": 33,
	"./bg": 34,
	"./bg.js": 34,
	"./bn": 35,
	"./bn.js": 35,
	"./bo": 36,
	"./bo.js": 36,
	"./br": 37,
	"./br.js": 37,
	"./bs": 38,
	"./bs.js": 38,
	"./ca": 39,
	"./ca.js": 39,
	"./cs": 40,
	"./cs.js": 40,
	"./cv": 41,
	"./cv.js": 41,
	"./cy": 42,
	"./cy.js": 42,
	"./da": 43,
	"./da.js": 43,
	"./de": 46,
	"./de-at": 44,
	"./de-at.js": 44,
	"./de-ch": 45,
	"./de-ch.js": 45,
	"./de.js": 46,
	"./dv": 47,
	"./dv.js": 47,
	"./el": 48,
	"./el.js": 48,
	"./en-au": 49,
	"./en-au.js": 49,
	"./en-ca": 50,
	"./en-ca.js": 50,
	"./en-gb": 51,
	"./en-gb.js": 51,
	"./en-ie": 52,
	"./en-ie.js": 52,
	"./en-nz": 53,
	"./en-nz.js": 53,
	"./eo": 54,
	"./eo.js": 54,
	"./es": 56,
	"./es-do": 55,
	"./es-do.js": 55,
	"./es.js": 56,
	"./et": 57,
	"./et.js": 57,
	"./eu": 58,
	"./eu.js": 58,
	"./fa": 59,
	"./fa.js": 59,
	"./fi": 60,
	"./fi.js": 60,
	"./fo": 61,
	"./fo.js": 61,
	"./fr": 64,
	"./fr-ca": 62,
	"./fr-ca.js": 62,
	"./fr-ch": 63,
	"./fr-ch.js": 63,
	"./fr.js": 64,
	"./fy": 65,
	"./fy.js": 65,
	"./gd": 66,
	"./gd.js": 66,
	"./gl": 67,
	"./gl.js": 67,
	"./gom-latn": 68,
	"./gom-latn.js": 68,
	"./he": 69,
	"./he.js": 69,
	"./hi": 70,
	"./hi.js": 70,
	"./hr": 71,
	"./hr.js": 71,
	"./hu": 72,
	"./hu.js": 72,
	"./hy-am": 73,
	"./hy-am.js": 73,
	"./id": 74,
	"./id.js": 74,
	"./is": 75,
	"./is.js": 75,
	"./it": 76,
	"./it.js": 76,
	"./ja": 77,
	"./ja.js": 77,
	"./jv": 78,
	"./jv.js": 78,
	"./ka": 79,
	"./ka.js": 79,
	"./kk": 80,
	"./kk.js": 80,
	"./km": 81,
	"./km.js": 81,
	"./kn": 82,
	"./kn.js": 82,
	"./ko": 83,
	"./ko.js": 83,
	"./ky": 84,
	"./ky.js": 84,
	"./lb": 85,
	"./lb.js": 85,
	"./lo": 86,
	"./lo.js": 86,
	"./lt": 87,
	"./lt.js": 87,
	"./lv": 88,
	"./lv.js": 88,
	"./me": 89,
	"./me.js": 89,
	"./mi": 90,
	"./mi.js": 90,
	"./mk": 91,
	"./mk.js": 91,
	"./ml": 92,
	"./ml.js": 92,
	"./mr": 93,
	"./mr.js": 93,
	"./ms": 95,
	"./ms-my": 94,
	"./ms-my.js": 94,
	"./ms.js": 95,
	"./my": 96,
	"./my.js": 96,
	"./nb": 97,
	"./nb.js": 97,
	"./ne": 98,
	"./ne.js": 98,
	"./nl": 100,
	"./nl-be": 99,
	"./nl-be.js": 99,
	"./nl.js": 100,
	"./nn": 101,
	"./nn.js": 101,
	"./pa-in": 102,
	"./pa-in.js": 102,
	"./pl": 103,
	"./pl.js": 103,
	"./pt": 105,
	"./pt-br": 104,
	"./pt-br.js": 104,
	"./pt.js": 105,
	"./ro": 106,
	"./ro.js": 106,
	"./ru": 107,
	"./ru.js": 107,
	"./sd": 108,
	"./sd.js": 108,
	"./se": 109,
	"./se.js": 109,
	"./si": 110,
	"./si.js": 110,
	"./sk": 111,
	"./sk.js": 111,
	"./sl": 112,
	"./sl.js": 112,
	"./sq": 113,
	"./sq.js": 113,
	"./sr": 115,
	"./sr-cyrl": 114,
	"./sr-cyrl.js": 114,
	"./sr.js": 115,
	"./ss": 116,
	"./ss.js": 116,
	"./sv": 117,
	"./sv.js": 117,
	"./sw": 118,
	"./sw.js": 118,
	"./ta": 119,
	"./ta.js": 119,
	"./te": 120,
	"./te.js": 120,
	"./tet": 121,
	"./tet.js": 121,
	"./th": 122,
	"./th.js": 122,
	"./tl-ph": 123,
	"./tl-ph.js": 123,
	"./tlh": 124,
	"./tlh.js": 124,
	"./tr": 125,
	"./tr.js": 125,
	"./tzl": 126,
	"./tzl.js": 126,
	"./tzm": 128,
	"./tzm-latn": 127,
	"./tzm-latn.js": 127,
	"./tzm.js": 128,
	"./uk": 129,
	"./uk.js": 129,
	"./ur": 130,
	"./ur.js": 130,
	"./uz": 132,
	"./uz-latn": 131,
	"./uz-latn.js": 131,
	"./uz.js": 132,
	"./vi": 133,
	"./vi.js": 133,
	"./x-pseudo": 134,
	"./x-pseudo.js": 134,
	"./yo": 135,
	"./yo.js": 135,
	"./zh-cn": 136,
	"./zh-cn.js": 136,
	"./zh-hk": 137,
	"./zh-hk.js": 137,
	"./zh-tw": 138,
	"./zh-tw.js": 138
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 184;

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conf_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conf_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__conf_json__);





var DataService = function () {
  function DataService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DataService);

    this.api = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
      baseURL: __WEBPACK_IMPORTED_MODULE_3__conf_json__["apiurl"],
      timeout: 30000
    });
    this.spotify = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
      baseURL: __WEBPACK_IMPORTED_MODULE_3__conf_json__["spotifyurl"],
      timeout: 30000
    });
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DataService, [{
    key: 'register',
    value: function register(code) {
      return this.api.post('/register/' + code);
    }
  }, {
    key: 'getProfile',
    value: function getProfile(headers) {
      return this.api.get('/profile', headers);
    }
  }, {
    key: 'getLocation',
    value: function getLocation(headers) {
      return this.api.get('/location', headers);
    }
  }, {
    key: 'addName',
    value: function addName(data, headers) {
      return this.api.post('/profile/name', data, headers);
    }
  }, {
    key: 'addEmail',
    value: function addEmail(data, headers) {
      return this.api.post('/profile/email', data, headers);
    }
  }, {
    key: 'changeNickname',
    value: function changeNickname(data, headers) {
      return this.api.put('/profile/nickname', data, headers);
    }
  }, {
    key: 'addSong',
    value: function addSong(data, headers) {
      return this.api.post('/songs', data, headers);
    }
  }, {
    key: 'addSuggestion',
    value: function addSuggestion(songId, headers) {
      return this.api.post('/suggestions/' + songId, null, headers);
    }
  }, {
    key: 'getSuggestions',
    value: function getSuggestions(headers) {
      return this.api.get('/suggestions', headers);
    }
  }, {
    key: 'voteSuggestion',
    value: function voteSuggestion(suggestionId, headers) {
      return this.api.post('/votes/' + suggestionId, null, headers);
    }
  }]);

  return DataService;
}();

/* harmony default export */ __webpack_exports__["a"] = (DataService);

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dataservice__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(218);





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var dataservice = new __WEBPACK_IMPORTED_MODULE_0__dataservice__["a" /* default */]();

var storage = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
	state: {
		profile: {
			credits: 0
		},
		location: {},
		suggestions: {},
		searchresult: {}
	},
	mutations: {
		updateProfile: function updateProfile(state, profile) {
			state.profile = profile;
		},
		updateLocation: function updateLocation(state, location) {
			state.location = location;
		},
		updateSuggestions: function updateSuggestions(state, suggestions) {
			state.suggestions = suggestions;
		},
		updateName: function updateName(state, name) {
			state.profile.first_name = name.split(" ")[0];
			state.profile.last_name = name.split(" ")[1];
		},
		updateEmail: function updateEmail(state, email) {
			state.profile.email = email;
		},
		updateNickname: function updateNickname(state, nickname) {
			state.profile.nick_name = nickname;
		},
		toggleVote: function toggleVote(state, votedId) {
			state.suggestions = state.suggestions.map(function (suggestion) {
				if (suggestion.id == votedId) {
					if (!suggestion.has_user_vote) {
						suggestion.has_user_vote = true;
						suggestion.votes++;
					} else {
						suggestion.has_user_vote = false;
						suggestion.votes--;
					}
				}
				return suggestion;
			});
		},
		decrementCredits: function decrementCredits(state) {
			state.profile.credits--;
		}
	},
	actions: {
		updateSuggestions: function updateSuggestions(_ref) {
			var commit = _ref.commit;

			dataservice.getSuggestions({ headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() }).then(function (response) {
				commit('updateSuggestions', response.data);
			}).catch(function (error) {
				console.log(error);
			});
		},
		updateName: function updateName(_ref2, name) {
			var commit = _ref2.commit;

			console.log(name.split(" ")[1]);
			var body = {
				first_name: name.split(" ")[0],
				last_name: name.split(" ")[1]
			};
			dataservice.addName(body, { headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() }).then(function (response) {
				console.log(response);
				commit('updateName', name);
			}).catch(function (error) {
				console.log(error);
			});
		},
		updateEmail: function updateEmail(_ref3, email) {
			var commit = _ref3.commit;

			var body = {
				email: email
			};
			dataservice.addEmail(body, { headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() }).then(function (response) {
				console.log(response);
				commit('updateEmail', email);
			}).catch(function (error) {
				console.log(error);
			});
		},
		updateNickname: function updateNickname(_ref4, nickname) {
			var commit = _ref4.commit;

			var body = {
				nick_name: nickname
			};
			dataservice.changeNickname(body, { headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() }).then(function (response) {
				console.log(response);
				commit('updateNickname', nickname);
			}).catch(function (error) {
				console.log(error);
			});
		},
		updateProfile: function updateProfile(_ref5) {
			var commit = _ref5.commit;

			dataservice.getProfile({ headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() }).then(function (response) {
				commit('updateProfile', response.data);
			}).catch(function (error) {
				console.log(error);
			});
		},
		updateLocation: function updateLocation(_ref6) {
			var commit = _ref6.commit;

			dataservice.getLocation({ headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() }).then(function (response) {
				commit('updateLocation', response.data);
				__WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].setSpotifyToken(response.data.spotify_token);
				console.log(response.data);
			}).catch(function (error) {
				console.log(error);
			});
		},
		addSuggestion: function addSuggestion(_ref7, song) {
			var commit = _ref7.commit;


			var body = {
				spotify_song_id: song.id,
				title: song.name,
				artist: song.artists.map(function (artist) {
					return artist.name;
				}).join(", "),
				img_url: song.album.images[2].url,
				duration_ms: song.duration_ms
			};

			dataservice.addSong(body, { headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() }).then(function (response) {
				dataservice.addSuggestion(response.data.id, { headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() }).then(function (response) {
					commit('decrementCredits');
					console.log('Suggestion added, bruh!');
				}).catch(function (error) {
					console.log(error);
				});
			}).catch(function (error) {
				console.log(error);
			});
		},
		toggleVote: function toggleVote(_ref8, suggestionId) {
			var commit = _ref8.commit;

			commit('toggleVote', suggestionId);

			dataservice.voteSuggestion(suggestionId, { headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() }).catch(function (error) {
				commit('toggleVote', suggestionId);
				console.log(error);
			});
		}
	}
});

/* harmony default export */ __webpack_exports__["a"] = (storage);

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.073029f.png";

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(213),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(214),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(210),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(215),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 210:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-body"
  }, [_c('h2', [_vm._v("Profile")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.first_name),
      expression: "user.first_name"
    }]
  }, [_vm._v("Vorname: " + _vm._s(_vm.user.first_name))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.last_name),
      expression: "user.last_name"
    }]
  }, [_vm._v("Nachname: " + _vm._s(_vm.user.last_name))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.email),
      expression: "user.email"
    }]
  }, [_vm._v("E-Mail-Adresse: " + _vm._s(_vm.user.email))]), _vm._v(" "), _c('p', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.nickname_change),
      expression: "!nickname_change"
    }]
  }, [_vm._v("Spitzname: " + _vm._s(_vm.user.nick_name))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nickname_change),
      expression: "nickname_change"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.nickname),
      expression: "nickname"
    }],
    staticClass: "ipt ipt--change",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nickname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nickname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.email || _vm.user.first_name),
      expression: "user.email || user.first_name"
    }],
    staticClass: "btn btn--change",
    on: {
      "click": _vm.changenickname
    }
  }, [_vm._v(_vm._s(_vm.change_button_text))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--facebook",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fbconnect
    }
  }, [_vm._v("\n    " + _vm._s(_vm.facebook_button_text) + "\n  ")]), _vm._v(" "), (!_vm.user.email) ? _c('div', [_c('button', {
    staticClass: "btn btn--email",
    attrs: {
      "type": "button",
      "disabled": !(_vm.email_address.indexOf('@') > -1) && _vm.email_add_address
    },
    on: {
      "click": _vm.addemail
    }
  }, [_vm._v("\n      " + _vm._s(_vm.add_email_text) + "\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.email_add_address),
      expression: "email_add_address"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email_address),
      expression: "email_address"
    }],
    staticClass: "ipt ipt--email",
    attrs: {
      "type": "email",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.email_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email_address = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn--logout",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n    Logout\n  ")])])
},staticRenderFns: []}

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.$route.path === '/')),
      expression: "!($route.path==='/' )"
    }],
    staticClass: "header"
  }, [_c('div', {
    staticClass: "status-bar"
  }, [_c('span', {
    staticClass: "status-bar__location"
  }, [_c('span', {
    staticClass: "status-bar__info"
  }, [_vm._v(_vm._s(_vm.location.location))])]), _vm._v(" "), _c('span', {
    staticClass: "status-bar__credits"
  }, [_c('span', {
    staticClass: "status-bar__info"
  }, [_vm._v("credits ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-volume-up"
  }), _vm._v(" \n\t\t\t" + _vm._s(_vm.credits) + "\n\t\t")])]), _vm._v(" "), _c('nav', {
    staticClass: "menu"
  }, [_c('router-link', {
    staticClass: "menu__entry",
    attrs: {
      "to": "/profile",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', [_vm._v("Profil")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu__entry",
    attrs: {
      "to": "/charts",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Charts")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu__entry",
    attrs: {
      "to": "/search",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus"
  }), _vm._v(" "), _c('span', [_vm._v("Vorschlagen")])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-body"
  }, [_c('h2', [_vm._v("Charts")]), _vm._v(" "), (_vm.charts.length > 0) ? _c('ul', {
    staticClass: "charts-list"
  }, _vm._l((_vm.charts), function(item) {
    return _c('li', {
      staticClass: "charts-entry song"
    }, [_c('div', {
      staticClass: "song__info"
    }, [_c('span', {
      staticClass: "song__title"
    }, [_vm._v(_vm._s(item.song.title))]), _vm._v(" "), _c('span', {
      staticClass: "song__artist"
    }, [_vm._v(_vm._s(item.song.artist))]), _vm._v(" "), _c('span', {
      staticClass: "song__suggestor"
    }, [_vm._v("vorgeschlagen von " + _vm._s(item.suggestor))])]), _vm._v(" "), _c('button', {
      staticClass: "song__action-btn",
      class: (item.has_user_vote) ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.vote(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-volume-up"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.votes))])])])
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-body checkin-view"
  }, [_c('img', {
    staticClass: "checkin-view__logo",
    attrs: {
      "src": __webpack_require__(200)
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Check In")]), _vm._v(" "), _c('form', {
    attrs: {
      "accept-charset": "utf-8"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('label', {
    staticClass: "lbl",
    attrs: {
      "for": "activation_code"
    }
  }, [_vm._v("\n      Gib deinen Code hier ein:\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activation_code),
      expression: "activation_code"
    }],
    staticClass: "ipt ipt--big",
    attrs: {
      "type": "text",
      "name": "activation_code",
      "placeholder": "",
      "maxlength": "8",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.activation_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.activation_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn--big",
    attrs: {
      "type": "submit",
      "disabled": _vm.activation_code.length < 8,
      "name": "submit"
    }
  }, [_vm._v("Einchecken")])])])
},staticRenderFns: []}

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-body"
  }, [_c('form', {
    staticClass: "search-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_query),
      expression: "search_query"
    }],
    staticClass: "form-ipt",
    attrs: {
      "type": "text",
      "name": "search_query",
      "placeholder": "Suchen...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.search_query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "form-btn",
    attrs: {
      "type": "submit",
      "name": "submit"
    }
  }, [_vm._v("Suchen")])]), _vm._v(" "), (_vm.results.length > 0) ? _c('ul', {
    staticClass: "search-results",
    attrs: {
      "id": "search-results"
    }
  }, [_c('h2', {
    staticClass: "search-results__title"
  }, [_vm._v("Resultate")]), _vm._v(" "), _vm._l((_vm.results), function(item) {
    return _c('li', {
      staticClass: "search-result song"
    }, [_c('img', {
      staticClass: "song__cover",
      attrs: {
        "src": item.album.images[2].url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "song__info"
    }, [_c('span', {
      staticClass: "song__title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "song__artist"
    }, [_vm._v(_vm._s(item.artists.map(function(artist) {
      return artist.name
    }).join(", ")))])]), _vm._v(" "), _c('button', {
      staticClass: "song__action-btn",
      on: {
        "click": function($event) {
          _vm.suggestSong(item, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle"
    })])])
  }), _vm._v(" "), (_vm.results.length >= (_vm.limit + _vm.offset)) ? _c('footer', {
    staticClass: "search-results__footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.showMoreResults
    }
  }, [_vm._v("Mehr Anzeigen")])]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dataservice__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__storage__ = __webpack_require__(2);






var dataservice = new __WEBPACK_IMPORTED_MODULE_3__dataservice__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({

	user: {
		authenticated: false
	},

	register: function register(code) {
		var _this = this;

		dataservice.register(code).then(function (response) {
			__WEBPACK_IMPORTED_MODULE_2_store___default.a.set('user_token', response.data.token);
			__WEBPACK_IMPORTED_MODULE_2_store___default.a.set('spotify_token', response.data.data.spotify_token);
			_this.user.authenticated = true;
			__WEBPACK_IMPORTED_MODULE_4__storage__["a" /* default */].profile = response.data.data;
			__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/profile');
		}).catch(function (error) {
			console.log(error);
		});
	},
	logout: function logout() {
		__WEBPACK_IMPORTED_MODULE_2_store___default.a.remove('user_token');
		this.user.authenticated = false;
		__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/');
	},
	checkAuth: function checkAuth() {
		if (__WEBPACK_IMPORTED_MODULE_2_store___default.a.get('user_token')) {
			this.user.authenticated = true;
		} else {
			this.user.authenticated = false;
		}
	},
	setSpotifyToken: function setSpotifyToken(token) {
		__WEBPACK_IMPORTED_MODULE_2_store___default.a.set('spotify_token', token);
	},
	getAuthHeader: function getAuthHeader() {
		return {
			'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_2_store___default.a.get('user_token')
		};
	},
	getSpotifyHeader: function getSpotifyHeader() {
		return {
			'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_2_store___default.a.get('spotify_token')
		};
	}
});

/***/ })

},[166]);


// WEBPACK FOOTER //
// static/js/app.0f49884425d7b1ab10b9.js